<template>
  <v-app id="passResetApp">
    <header-item />
    <v-content>
      <v-container>
        <v-row
          dense
          align="center"
          max-width="100"
        >
          <v-col
            cols="12"
            sm="12"
            md="12"
            align="center"
          >
            <h2>クラウドフォルダー パスワードリセット</h2>
          </v-col>
        </v-row>
        
        <v-stepper v-model="e1">
          <v-stepper-header>
            <template v-for="n in stepDef">
              <v-stepper-step
                :key="`${n.index}-step`"
                :complete="e1 > n.index"
                :step="n.index"
              >
                {{ n.title }}
              </v-stepper-step>
  
              <v-divider
                v-if="n.index !== stepDef.length"
                :key="n.index"
              />
            </template>
          </v-stepper-header>
          <v-stepper-items>
            <template v-for="n in stepDef">
              <v-stepper-content
                :key="`${n.index}-step`"
                :step="n.index"
              >
                <div v-if="n.index == 1">
                  <v-card
                    color="lighten-1"
                    flat
                  >
                    <v-row
                      dense
                      max-width="100"
                    >
                      <!-- 確認キー確認メッセージ -->
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <span>
                          登録したメールアドレスへ確認キーを送信しました。確認キーと新しいパスワードを入力してください。
                        </span>
                      </v-col>
                      <!-- 確認キー -->
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="1"
                        xl="1"
                      />
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                      >
                        <span>
                          確認キー<required-mark />
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="6"
                        xl="6"
                      >
                        <v-text-field
                          v-model="confCode"
                          required
                          counter="6"
                          maxlength="6"
                          :rules="[v => !!v || &quot;確認キーは必須です&quot;]"
                          hint="メールアドレスに送信したメール内に記載されている確認キーを入力してください"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="3"
                        xl="3"
                      />
                      <!-- 確認キーを送信 -->
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="1"
                        xl="1"
                      />
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                      >
                        <span>
                          新しいパスワード<required-mark />
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="6"
                        xl="6"
                      >
                        <create-password-field ref="CreatePasswordField" />
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="3"
                        xl="3"
                      />
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="1"
                        xl="1"
                      />
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                      >
                        <span>
                          新しいパスワード確認<required-mark />
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="6"
                        xl="6"
                      >
                        <password-field ref="PasswordField" />
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="3"
                        xl="3"
                      />
                    </v-row>
                    <v-col
                      cols="12"
                      align="center"
                    >
                      <v-btn
                        color="primary"
                        :loading="loadingReReg"
                        :disabled="loadingReReg"
                        @click="nextStepCheck(Number(`${n.index}`));"
                      >
                        再登録
                      </v-btn>
                    </v-col>
                  </v-card>
                </div>
                <div v-if="n.index == 2">
                  <v-card
                    color="lighten-1"
                    flat
                  >
                    <v-row
                      dense
                      max-width="100"
                    >
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <span>
                          パスワードリセットが完了しました。新しいパスワードでログインが可能になります。
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          color="primary"
                          @click="nextStepCheck(Number(`${n.index}`));"
                        >
                          ログイン画面へ
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </v-stepper-content>
            </template>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-content>
    <msg-dlg ref="MsgDlg" />
  </v-app>
</template>

<script>

import HeaderItem from './HeaderItem.vue';
import Amplify, {Constant, RestApiUtil, Logger} from '../amplify_com.js';
import MsgDlg from './MsgDlg.vue';
import RequiredMark from './RequiredMark.vue';
import CreatePasswordField from './CreatePasswordField.vue';
import PasswordField from './PasswordField.vue';

export default {  
  components: {
    'header-item': HeaderItem,
    'msg-dlg': MsgDlg,
    'required-mark': RequiredMark,
    'create-password-field': CreatePasswordField,
    'password-field': PasswordField,
  },
  data: () => ({
    Constant :Constant, // template内で定数クラスを使用するため
    loadingReReg: false, //連打防止用
    // ステップ定義
    stepDef: [
      { 
        index : 1,
        title : 'パスワードリセット', 
        checkFunc: async function(app){
          app.userPass = app.$refs.CreatePasswordField[0].getPassword();
          app.userPassCf = app.$refs.PasswordField[0].getPassword();

          if(!app.confCode){
            app.$refs.MsgDlg.showError('確認キーを入力してください');
            return false;
          }
          if(!app.userPass){
            app.$refs.MsgDlg.showError('新しいパスワードを入力してください');
            return false;
          }
          if(!app.userPassCf){
            app.$refs.MsgDlg.showError('新しいパスワード確認を入力してください');
            return false;
          }
          if(app.userPass === app.userId){
            app.$refs.MsgDlg.showError('ユーザーIDと同じパスワードは入力不可です');
            return false;
          }
          if(app.userPass !== app.userPassCf){
            app.$refs.MsgDlg.showError('パスワードとパスワード確認には同じパスワードを入力してください');
            return false;
          }
          //ボタン無効化
          app.loadingReReg = true;
          
          // パスワードリセット
          let result = false;
          await Amplify.Auth.forgotPasswordSubmit(
            app.userId,
            app.confCode,
            app.userPassCf,
          ).then(() => {
            result = true;
          }).catch(err => {
            app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
            app.loadingReReg = false;
            result = false;
          });
          return result;
        },
        okFunc: function(app, now_index){
          app.$refs.MsgDlg.showSuccess('パスワードリセットに成功しました。');
          app.nextStep(now_index + 1);
          app.loadingReReg = false;
        },
      },
      { 
        index : 2,
        title : '完了', 
        checkFunc: function(){
          return true;
        },
        okFunc: function(app, now_index){
          // 次へ
          app.nextStep(now_index + 1);
        },
      },
    ],
    e1: 1,
    steps: 2,
    userId: '',
    confCode: '',
    userPass: '',
    userPassCf: '',
  }),
  watch: {
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
    userId(val) {
      this.$refs.CreatePasswordField[0].setUserId(val);
    },
  },
  beforeCreate : function () {
    // 念のため、サインしているならサインアウト
    Amplify.Auth.currentUserPoolUser().then(() => {
        Amplify.Auth.signOut();
    }).catch(err => {
      // エラー発生しても無視
      Logger.log(err);
    });

    // キーチェック
    let _this = this;
    if(_this.$route.query.key){
      let key = _this.$route.query.key;
      // キーチェックrestAPIを実施。
      RestApiUtil.PostMailTokenAuth(key).then(mailTokenAuth => {
        // チェック
        if(!(mailTokenAuth.next_url.endsWith(key))){
          // この画面を表示する権限がないので戻る
          _this.$router.push({ path: "/" }, () => {}, () => {});
        }
        // apiから取得したユーザーIDを設定（ユーザーID変更なければuser_name、変更後なら優先user_name）
        _this.userId = mailTokenAuth.preferred_user_name ? mailTokenAuth.preferred_user_name : mailTokenAuth.user_name;
      }).catch(error => {
        Logger.log(error);
        // この画面を表示する権限がないので戻る
        _this.$router.push({ path: "/" }, () => {}, () => {});
      });
    } else {
      // この画面を表示する権限がないので戻る
      _this.$router.push({ path: "/" }, () => {}, () => {});
    }
  },
  mounted() {
    //戻るボタン無効化
    history.pushState(null, null, null);
    window.addEventListener("popstate", function () {
      history.pushState(null, null, null);
      return;
    });
  },
  methods: {
    nextStepCheck : async function(n) {
      var curDef = this.stepDef[n-1];
      if(await curDef.checkFunc(this)){
        curDef.okFunc(this, n);
      }
    },
    nextStep (n) {
      if (n === this.steps + 1) {
        // 次のステップはないのでログイン画面へ遷移
        this.$router.push({ path: "/" }, () => {}, () => {});
      } else {
        this.e1 = n
      }
    },
  }
};
</script>

<style>
.v-application--wrap {min-height:0;}
</style>